import type { ReactNode } from 'react';

/* Tab bar glyphs, drawn in one 1.7px stroke so they read as a family. */
const TAB_ICONS: Record<string, ReactNode> = {
  '/': <path d="M4 11.5 12 5l8 6.5V19a1 1 0 0 1-1 1h-4.5v-5h-5v5H5a1 1 0 0 1-1-1z" />,
  '/cobrar': (
    <>
      <rect x="3" y="6" width="18" height="12" rx="2.5" />
      <path d="M3 10.5h18M7 14.5h3" />
    </>
  ),
  '/pagos': <path d="M6 3h12v18l-3-2-3 2-3-2-3 2zM9 8.5h6M9 12.5h6" />,
  '/clientes': (
    <>
      <circle cx="9" cy="8" r="3.5" />
      <path d="M2.5 20a6.5 6.5 0 0 1 13 0M15.5 4.6a3.5 3.5 0 0 1 0 6.8M17.5 13.6a6.5 6.5 0 0 1 4 6.4" />
    </>
  ),
  '/historial': (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3 2" />
    </>
  ),
  '/clases': (
    <>
      <circle cx="12" cy="5" r="2" />
      <path d="M4.5 10.5 12 9l7.5 1.5M12 9v5.5M12 14.5 8 20.5M12 14.5l4 6" />
    </>
  ),
  '/reservas': (
    <>
      <rect x="3.5" y="5" width="17" height="15" rx="2.5" />
      <path d="M3.5 9.5h17M8 3v4M16 3v4" />
    </>
  ),
  '/calendario': (
    <>
      <rect x="3.5" y="5" width="17" height="15" rx="2.5" />
      <path d="M3.5 9.5h17M8 3v4M16 3v4M9.5 9.5V20M14.5 9.5V20" />
    </>
  ),
  '/inteligencia': (
    <>
      <circle cx="12" cy="12" r="7.5" />
      <path d="M4.5 12h15M12 4.5c2.2 2 3.3 4.5 3.3 7.5s-1.1 5.5-3.3 7.5M12 4.5C9.8 6.5 8.7 9 8.7 12s1.1 5.5 3.3 7.5" />
    </>
  ),
  '/finanzas': <path d="M4 19.5h16M6.5 16V11M11 16V6.5M15.5 16v-7M20 16v-4" />,
  '/bandeja': <path d="M3.5 13.5 6 5.5h12l2.5 8V19a1 1 0 0 1-1 1h-15a1 1 0 0 1-1-1zM3.5 13.5H9l1 2h4l1-2h5.5" />,
  '/agentes': (
    <>
      <circle cx="12" cy="12" r="3" />
      <circle cx="5" cy="7" r="1.6" />
      <circle cx="19" cy="7" r="1.6" />
      <circle cx="5" cy="17" r="1.6" />
      <circle cx="19" cy="17" r="1.6" />
    </>
  ),
  more: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <circle cx="8" cy="12" r="0.9" fill="currentColor" />
      <circle cx="12" cy="12" r="0.9" fill="currentColor" />
      <circle cx="16" cy="12" r="0.9" fill="currentColor" />
    </>
  ),
};

export function TabIcon({ name }: { name: string }) {
  const glyph = TAB_ICONS[name];
  if (!glyph) return null;
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      {glyph}
    </svg>
  );
}
